(function(){
  /* Pagini pline în categorii.
     Shopify paginează după PRODUSE (24/pagină), dar produsele cu mai multe dimensiuni au câte un card per dimensiune,
     deci o pagină poate avea 25-30 de carduri -> ultimul rând incomplet. Aici: cardurile care ar rămâne pe un rând
     incomplet se mută la începutul paginii următoare. Grupul R=12 dă rânduri pline la 4, 3 și 2 coloane.
     Doar ultima pagină poate avea rând incomplet. Nimic nu se pierde: ce ascunde pagina k apare pe pagina k+1.
     Numărul de carduri pe produs vine din ?view=amccount (templates/collection.amccount.liquid), 250 de produse/cerere. */
  var R=12, WIN=250;
  var grid=document.querySelector(".col-grid[data-page]"); if(!grid) return;
  var cur=parseInt(grid.getAttribute("data-page"),10)||1, last=parseInt(grid.getAttribute("data-pages"),10)||1;
  var per=parseInt(grid.getAttribute("data-per"),10)||24;
  if(last<=1) return;
  var sec=grid.closest('[id^="shopify-section-"]'); var sid=sec ? sec.id.replace("shopify-section-","") : null;
  function done(){ grid.classList.remove("is-arranging"); }
  function withParams(set,del){
    var u=new URL(location.href); (del||[]).forEach(function(k){ u.searchParams.delete(k); });
    Object.keys(set).forEach(function(k){ u.searchParams.set(k,set[k]); }); return u.pathname+u.search;
  }
  // numărul de carduri pentru primele `nProducts` produse (în ordinea curentă)
  function countsUpTo(nProducts){
    var wins=Math.ceil(nProducts/WIN), reqs=[];
    for(var w=1; w<=wins; w++){
      reqs.push(fetch(withParams({view:"amccount",page:w},["section_id"])).then(function(r){ return r.text(); }).then(function(t){ var a=JSON.parse(t); if(!Array.isArray(a)) throw 0; return a; }));
    }
    return Promise.all(reqs).then(function(parts){ var all=[]; parts.forEach(function(p){ all=all.concat(p); }); return all.slice(0,nProducts); });
  }
  // cardurile (HTML) de pe pagina p, cum le randează serverul
  function cardsOf(p){
    return fetch(withParams(sid?{page:p,section_id:sid}:{page:p})).then(function(r){ return r.text(); }).then(function(h){
      var d=new DOMParser().parseFromString(h,"text/html");
      return [].slice.call(d.querySelectorAll(".col-grid .p-card"));
    });
  }
  var own=[].slice.call(grid.querySelectorAll(".p-card"));
  (cur>1 ? countsUpTo((cur-1)*per) : Promise.resolve([])).then(function(counts){
    var before=0; counts.forEach(function(n){ before+=n; });          // carduri pe paginile anterioare
    var lead=before%R;                                               // carduri mutate aici de pe pagina anterioară
    var hide=(cur<last) ? (before+own.length)%R : 0;                 // carduri mutate pe pagina următoare
    own.slice(own.length-hide).forEach(function(c){ c.remove(); });
    if(!lead) return;
    return cardsOf(cur-1).then(function(prev){
      var first=grid.querySelector(".p-card");
      prev.slice(-lead).forEach(function(c){
        var n=document.importNode(c,true); grid.insertBefore(n, first);
        if(window.amcInitCard) window.amcInitCard(n);
      });
    });
  }).then(done).catch(done);
})();
